/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Section_CompanyInputs */

const de_commons_footer_section_company = /** @type {(inputs: Commons_Footer_Section_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/** @type {(inputs: Commons_Footer_Section_CompanyInputs) => LocalizedString} */
const en_commons_footer_section_company = de_commons_footer_section_company;

/**

* @param {Commons_Footer_Section_CompanyInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_section_company = /** @type {((inputs?: Commons_Footer_Section_CompanyInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Section_CompanyInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_section_company(inputs)
	return en_commons_footer_section_company(inputs)
});